<template>
	<v-card :loading="loading" class="mx-auto">
		<v-text-field
			v-if="searchProp"
			v-model="search"
			class="ml-3 mr-4"
			:label="searchLabel"
			clearable
		>
			<v-icon slot="prepend" class="mt-1" color="grey lighten-1" small
				>fa-search</v-icon
			>
		</v-text-field>

		<v-list flat>
			<v-list-item
				v-for="item in filteredItems"
				:key="id(item)"
				:class="['list-item', { active: active(item) }]"
				@click="$emit('click', item)"
			>
				<slot :item="item" :active="active(item)" />
			</v-list-item>
		</v-list>
	</v-card>
</template>

<script>
import { searchAndSort } from "@/utils/vuex";

export default {
	props: {
		loading: {
			type: Boolean,
			default: false,
		},

		searchLabel: {
			type: String,
			default: "Search",
		},

		searchProp: {
			type: String,
			default: "name",
		},

		items: {
			type: Array[Object],
			required: true,
		},

		activeItem: {
			type: Object,
			default: null,
		},
	},

	data() {
		return {
			search: "",
		};
	},

	computed: {
		filteredItems() {
			if (!this.searchProp) return this.items;

			return searchAndSort(this.items, this.search, {
				searchIteratee: this.searchProp,
				sortIteratee: this.searchProp,
			});
		},
	},

	methods: {
		id: item => item.guid || item.id,

		active(item) {
			if (!item || !this.activeItem) return false;
			return this.id(this.activeItem) === this.id(item) || undefined;
		},
	},
};
</script>
